import { render, staticRenderFns } from "./OctUserCard.vue?vue&type=template&id=1bc9b884&scoped=true&"
import script from "./OctUserCard.vue?vue&type=script&lang=js&"
export * from "./OctUserCard.vue?vue&type=script&lang=js&"
import style0 from "./OctUserCard.vue?vue&type=style&index=0&id=1bc9b884&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc9b884",
  null
  
)

export default component.exports